"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateRoyaltyTier = exports.deleteRoyaltyTier = exports.addRoyaltyTier = void 0;
const anchor_1 = require("@project-serum/anchor");
const utils_1 = require("../utils");
function addRoyaltyTier({ connection, updateAuthorityAccount, registeredCurrency, stakeAmount, discount, programId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getMarketplaceProgram)({ connection, programId });
        const ixSet = {
            signers: [],
            instructions: [],
        };
        const ix = yield program.methods
            .addRoyaltyTier(new anchor_1.BN(stakeAmount), new anchor_1.BN(discount))
            .accounts({
            updateAuthorityAccount,
            registeredCurrency,
        })
            .instruction();
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.addRoyaltyTier = addRoyaltyTier;
function deleteRoyaltyTier({ connection, updateAuthorityAccount, registeredCurrency, stakeAmount, programId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getMarketplaceProgram)({ connection, programId });
        const ixSet = {
            signers: [],
            instructions: [],
        };
        const ix = yield program.methods
            .deleteRoyaltyTier(new anchor_1.BN(stakeAmount))
            .accounts({
            updateAuthorityAccount,
            registeredCurrency,
        })
            .instruction();
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.deleteRoyaltyTier = deleteRoyaltyTier;
function updateRoyaltyTier({ connection, updateAuthorityAccount, registeredCurrency, stakeAmount, discount, programId, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, utils_1.getMarketplaceProgram)({ connection, programId });
        const ixSet = {
            signers: [],
            instructions: [],
        };
        const ix = yield program.methods
            .updateRoyaltyTier(new anchor_1.BN(stakeAmount), new anchor_1.BN(discount))
            .accounts({
            updateAuthorityAccount,
            registeredCurrency,
        })
            .instruction();
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.updateRoyaltyTier = updateRoyaltyTier;
//# sourceMappingURL=royaltyTiers.js.map